import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
    private fieldSorter = fields => (a, b) =>
        fields
            .map(o => {
                let dir = 1;
                if (o[0] === '-') {
                    dir = -1;
                    o = o.substring(1);
                }
                return a[o] > b[o] ? dir : a[o] < b[o] ? -dir : 0;
            })
            .reduce((p, n) => (p ? p : n), 0);

    transform(value: Array<any>, arg?: string): Array<any> {
        if (!value) {
            return;
        }
        const newArray = Array.from(value);
        if (arg) {
            const props = arg.split(',');
            return newArray.sort(this.fieldSorter(props));
        } else {
            return newArray.sort((a, b) => a.localeCompare(b));
        }
    }
}
